import { render, staticRenderFns } from "./RemarcarCombo.vue?vue&type=template&id=fb4bc59a&"
import script from "./RemarcarCombo.vue?vue&type=script&lang=js&"
export * from "./RemarcarCombo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports